import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './styles/AnouncementCard.css';

export function CardColumns() {
    const { t } = useTranslation();
    const [announcementData, setAnnouncementData] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(
                    "https://api.jsonbin.io/v3/b/677d3e0bacd3cb34a8c58606/latest",
                    {
                        headers: {
                            "X-Master-Key": "$2a$10$g9HFN7jTfYswexcES.bBuOx0cARlZHwZ6eQHA6.JDZTbkAwi9CWXa",
                        },
                    }
                );

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const data = await response.json();
                console.log("API Response:", data); // Debugging: Log the API response
                setAnnouncementData(data.record.announcementData); // Update based on API structure
            } catch (err) {
                console.error("Error fetching announcement data:", err); // Log error for debugging
                setError(err.message || "An error occurred");
            }
        };

        fetchData();
    }, []); // Empty dependency array ensures this runs only once on mount

    return (
        <div className="card-columns-container">
            {/* Announcement Section */}
            <div className="announcement-section">
                {error ? (
                    <p className="error-message">{error}</p>
                ) : announcementData ? (
                    <>
                        <h2 className="announcement-title">{t('announcements.title')}</h2>
                        <p className="announcement-description">
                            {t('announcements.description')}
                        </p>
                        <div className="announcement-details">
                            <div>
                                <h3 className="training-details">
                                    {t('announcements.venue')} <span>{announcementData.venue}</span>
                                </h3>
                            </div>
                            <a href="/reach-us" className="register-btn">
                                {t('announcements.registerNow')}
                            </a>
                        </div>
                    </>
                ) : (
                    <p>{t('announcements.loading')}</p>
                )}
            </div>

            {/* Cards Section */}
            <div className="card-columns">
                <Card
                    title={t('announcements.qtTraining.title')}
                    description={
                        <ul>
                            <li>{t('announcements.qtTraining.fundamentals')}</li>
                            <li>{t('announcements.qtTraining.advance')}</li>
                            <li>{t('announcements.qtTraining.qt3d')}</li>
                        </ul>
                    }
                    link="#"
                />
                <Card
                    title={t('announcements.qmlTraining.title')}
                    description={
                        <ul>
                            <li>{t('announcements.qmlTraining.essentials')}</li>
                            <li>{t('announcements.qmlTraining.advance')}</li>
                            <li>{t('announcements.qmlTraining.qml3d')}</li>
                        </ul>
                    }
                    link="#"
                />
                <Card
                    title={t('announcements.modernCpp.title')}
                    description={
                        <ul>
                            <li>{t('announcements.modernCpp.artOfCpp')}</li>
                            <li>{t('announcements.modernCpp.cppVersions')}</li>
                            <li>{t('announcements.modernCpp.performanceAnalysis')}</li>
                        </ul>
                    }
                    link="#"
                />
                <Card
                    title={t('announcements.advancedTraining.title')}
                    description={
                        <ul>
                            <li>{t('announcements.advancedTraining.qtInternals')}</li>
                            <li>{t('announcements.advancedTraining.openGL')}</li>
                            <li>{t('announcements.advancedTraining.unity3d')}</li>
                        </ul>
                    }
                    link="#"
                />




            </div>
        </div>
    );
}

function Card({ title, description, link }) {
    const { t } = useTranslation();
    return (
        <div className="card">
            <div className="card-overlay"></div>
            <div className="card-content">
                <h3 className="card-title">{title}</h3>
                <p className="card-description">{description}</p>
                <a href={link} className="card-btn">{t('announcements.learnMore')}</a>
            </div>
        </div>
    );
}
